/** sessionStorage: skip duplicate sanctum call (one-time proctored return URL is single-use). */
export const PROCTORED_OTU_SESSION_STORAGE_KEY =
    "mod_candidate_proctored_otu_uuid";
